import React, { useEffect, useState } from 'react';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Swal from 'sweetalert2'
import _ from 'lodash';
import { listaEventos, buscaPagamentos, listaTransmissoes, buscaEmailsMarketing } from '../../services/mysql'
import moment from 'moment/moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import TabelaPagamentos from "./TabelaPagamentos";
import TabelaPagamentosVideos from "./TabelaPagamentosVideos";


export default function Pagamentos() {
    const [academias, setAcademias] = useState([])
    const [eventos, setEventos] = useState([])
    const [transmissoes, setTransmissoes] = useState([])
    const [evento, setEvento] = useState('')
    const [mesAno, setMesAno] = useState(moment().format('YYYY-MM'))
    const [tipoEvento, setTipoEvento] = useState('eventos')
    const [filtro] = useState({
        anoMes: moment().format('YYYY-MM'),
        idEvento: null,
        tipoEvento: 'eventos',
        idProdutor: '',
        perfil: ''
    })
    const [listaExcel, setListaExcel] = useState([])

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('userd7'))
        mensagemLoading('Carregando Dados...')
        const data = {
            id: user.id,
            perfil: user.perfil
        }
        listaEventos(data).then((res) => {
            if (res.erro) {
                mensagemErro(res.message)
            } else {
                setEventos(res)
            }
            Swal.close()
        })
        listaTransmissoes(data).then((res) => {
            if (res.erro) {
                mensagemErro(res.message)
            } else {
                setTransmissoes(res)
            }
            Swal.close()
        })
    }, {})

    function filtrar() {
        const user = JSON.parse(localStorage.getItem('userd7'))
        setAcademias([])
        filtro.anoMes = mesAno
        filtro.idEvento = evento ? evento : null
        filtro.tipoEvento = tipoEvento
        filtro.idProdutor = user.id
        filtro.perfil = user.perfil
        mensagemLoading('Buscando pagamentos...')
        if (filtro.anoMes) {
            buscaPagamentos(filtro).then((res) => {
                if (res.erro) {
                    Swal.close()
                    mensagemAlerta(res.message)
                } else {
                    Swal.close()
                    const vipFalse = res.pagamentos.filter(item => !item.salaVip).sort((a, b) => moment(b.dataPagamento).diff(moment(a.dataPagamento)));
                    const vipTrue = res.pagamentos.filter(item => item.salaVip).sort((a, b) => moment(b.dataPagamento).diff(moment(a.dataPagamento)));

                    const tabelaFalse = vipFalse.map((item, index) => ({
                        numero: index + 1,
                        salaVip: false,
                        ...item
                    }));

                    const tabelaTrue = vipTrue.map((item, index) => ({
                        numero: index + 1,
                        salaVip: true,
                        ...item
                    }));
                    const tabelaFinal = [...tabelaFalse, ...tabelaTrue];
                    setAcademias(tabelaFinal)
                    setListaExcel(tabelaFinal)
                }
            })
        } else {
            buscaEmailsMarketing(filtro).then((res) => {
                if (res.erro) {
                    Swal.close()
                    mensagemAlerta(res.message)
                } else {
                    Swal.close()
                    const vipFalse = res.pagamentos.filter(item => !item.salaVip).sort((a, b) => moment(b.dataPagamento).diff(moment(a.dataPagamento)));
                    const vipTrue = res.pagamentos.filter(item => item.salaVip).sort((a, b) => moment(b.dataPagamento).diff(moment(a.dataPagamento)));

                    const tabelaFalse = vipFalse.map((item, index) => ({
                        numero: index + 1,
                        salaVip: false,
                        ...item
                    }));

                    const tabelaTrue = vipTrue.map((item, index) => ({
                        numero: index + 1,
                        salaVip: true,
                        ...item
                    }));
                    const tabelaFinal = [...tabelaFalse, ...tabelaTrue];
                    setAcademias(tabelaFinal)
                    setListaExcel(tabelaFinal)
                }
            })
        }


    }

    function exportToExcel() {

        var nomeEvento = tipoEvento == 'eventos'
            ? eventos.filter((d) => d.id === parseInt(evento))[0].nome
            : transmissoes.filter((d) => d.id === parseInt(evento))[0].nome;

        // Separar os dados
        const free = listaExcel.filter(item => item.free === 'SIM');
        const pagantes = listaExcel.filter(item => !item.salaVip && item.free !== 'SIM');
        const vips = listaExcel.filter(item => item.salaVip);

        const dadosTodos = listaExcel.map((item, index) => ({
            "Ordem": item.numero,
            "Nome": item.nomeUsuario,
            "CPF": item.cpf,
            "Email": item.email,
            "Valor": item.valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
            "Desconto": item.desconto ? parseFloat(item.desconto).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : 'R$ 0,00',
            "Total": (item.valor - parseFloat(item.desconto ?? 0)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
            "Vip": item.salaVip ? "Sim" : "Não",
            "Free": item.free === 'SIM' ? "Sim" : "Não",
            "Cupom": item.cupom ? item.cupom : 'Sem Cupom',
            "Data Cadastro": moment(item.data_cadastro).format('DD/MM/YYYY - HH:mm'),
            "Data do Pagamento": item.dataPagamento ? moment(item.dataPagamento).format('DD/MM/YYYY - HH:mm') : "Free"
        }));

        // Formatar dados Pagantes
        const dadosPagantes = pagantes.map((item, index) => ({
            "Ordem": item.numero,
            "Nome": item.nomeUsuario,
            "CPF": item.cpf,
            "Email": item.email,
            "Valor": item.valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
            "Desconto": item.desconto ? parseFloat(item.desconto).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : 'R$ 0,00',
            "Total": (item.valor - parseFloat(item.desconto ?? 0)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
            "Vip": "Não",
            "Free": "Não",
            "Cupom": item.cupom ? item.cupom : 'Sem Cupom',
            "Data Cadastro": moment(item.data_cadastro).format('DD/MM/YYYY - HH:mm'),
            "Data do Pagamento": item.dataPagamento ? moment(item.dataPagamento).format('DD/MM/YYYY - HH:mm') : "Free"
        }));

        // Formatar dados VIP
        const dadosVip = vips.map((item, index) => ({
            "Ordem": item.numero,
            "Nome": item.nomeUsuario,
            "CPF": item.cpf,
            "Email": item.email,
            "Valor": item.valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
            "Desconto": item.desconto ? parseFloat(item.desconto).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : 'R$ 0,00',
            "Total": (item.valor - parseFloat(item.desconto ?? 0)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
            "Vip": "Sim",
            "Free": item.free === 'SIM' ? "Sim" : "Não",
            "Cupom": item.cupom ? item.cupom : 'Sem Cupom',
            "Data Cadastro": moment(item.data_cadastro).format('DD/MM/YYYY - HH:mm'),
            "Data do Pagamento": item.dataPagamento ? moment(item.dataPagamento).format('DD/MM/YYYY - HH:mm') : "Free"
        }));

        const dadosFree = free.map((item, index) => ({
            "Número": item.numero,
            "Nome": item.nomeUsuario,
            "CPF": item.cpf,
            "Email": item.email,
            "Valor": item.valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
            "Desconto": item.desconto ? parseFloat(item.desconto).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }) : 'R$ 0,00',
            "Total": (item.valor - parseFloat(item.desconto ?? 0)).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }),
            "Vip": item.salaVip ? "Sim" : "Não",
            "Free": item.free === 'SIM' ? "Sim" : "Não",
            "Cupom": item.cupom ? item.cupom : 'Sem Cupom',
            "Data Cadastro": moment(item.data_cadastro).format('DD/MM/YYYY - HH:mm'),
            "Data do Pagamento": item.dataPagamento ? moment(item.dataPagamento).format('DD/MM/YYYY - HH:mm') : "Free"
        }));

        // Criar planilhas
        const worksheetTodos = XLSX.utils.json_to_sheet(dadosTodos);
        worksheetTodos["!cols"] = [
            { wch: 10 }, // Número
            { wch: 40 }, // Nome
            { wch: 18 }, // CPF
            { wch: 40 }, // Email
            { wch: 15 }, // Valor
            { wch: 15 }, // Desconto
            { wch: 15 }, // Total
            { wch: 10 }, // Vip
            { wch: 10 }, // Free
            { wch: 20 }, // Cupom
            { wch: 25 }, // Data Cadastro
            { wch: 25 }, // Data Pagamento
        ];
        const worksheetPagantes = XLSX.utils.json_to_sheet(dadosPagantes);
        worksheetPagantes["!cols"] = [
            { wch: 10 }, // Número
            { wch: 40 }, // Nome
            { wch: 18 }, // CPF
            { wch: 40 }, // Email
            { wch: 15 }, // Valor
            { wch: 15 }, // Desconto
            { wch: 15 }, // Total
            { wch: 10 }, // Vip
            { wch: 10 }, // Free
            { wch: 20 }, // Cupom
            { wch: 25 }, // Data Cadastro
            { wch: 25 }, // Data Pagamento
        ];
        const worksheetVip = XLSX.utils.json_to_sheet(dadosVip);
        worksheetVip["!cols"] = [
            { wch: 10 }, // Número
            { wch: 40 }, // Nome
            { wch: 18 }, // CPF
            { wch: 40 }, // Email
            { wch: 15 }, // Valor
            { wch: 15 }, // Desconto
            { wch: 15 }, // Total
            { wch: 10 }, // Vip
            { wch: 10 }, // Free
            { wch: 20 }, // Cupom
            { wch: 25 }, // Data Cadastro
            { wch: 25 }, // Data Pagamento
        ];
        const worksheetFree = XLSX.utils.json_to_sheet(dadosFree);
        worksheetFree["!cols"] = [
            { wch: 10 }, // Número
            { wch: 40 }, // Nome
            { wch: 18 }, // CPF
            { wch: 40 }, // Email
            { wch: 15 }, // Valor
            { wch: 15 }, // Desconto
            { wch: 15 }, // Total
            { wch: 10 }, // Vip
            { wch: 10 }, // Free
            { wch: 20 }, // Cupom
            { wch: 25 }, // Data Cadastro
            { wch: 25 }, // Data Pagamento
        ];

        // Criar workbook
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheetTodos, 'Todos');
        XLSX.utils.book_append_sheet(workbook, worksheetPagantes, 'Pagantes');
        XLSX.utils.book_append_sheet(workbook, worksheetVip, 'Vip');
        XLSX.utils.book_append_sheet(workbook, worksheetFree, 'Free');

        // Gerar arquivo
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

        saveAs(blob, `Relatório de Pagamentos - ${nomeEvento + " - " + mesAno}.xlsx`);
    }

    const handleMesAno = (event) => {
        event.persist();
        setMesAno(event.target.value);
    }
    const handleTipoPagamento = (event) => {
        setAcademias([])
        event.persist();
        if (event.target.value === 'transmissao') {
            setTipoEvento('transmissao')
        } else {
            setTipoEvento('eventos')
        }
    }
    const handleEvento = (event) => {
        event.persist();
        if (event.target.value === 'all') {
            setEvento(null)
        } else {
            setEvento(event.target.value);
        }
    }

    // Mensagens
    function mensagemAlerta(msg) {
        Swal.fire('Alerta', msg, 'warning')
    }

    function mensagemErro(msg) {
        Swal.fire('Erro', msg, 'error')
    }
    function mensagemSucesso(msg) {
        Swal.fire('Sucesso', msg, 'success').then(() => {
            mensagemLoading('Atualizando Vídeos...')
            listaEventos().then((res) => {
                Swal.close()
                setAcademias(res)
            })
        })
    }

    function mensagemLoading(msg) {
        Swal.fire({
            title: 'Aguarde',
            html: msg,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            },
        })
    }
    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Menu />
                <div class="layout-page">
                    <div>
                        <Header />
                        <div className="content-wrapper">
                            <div className="container-xxl flex-grow-1 " style={{ marginTop: 20 }}>
                                <div className="card">
                                    <div className='row'>
                                        <div className='col-md-10'>
                                            <h5 className="card-header">Pagamentos</h5>
                                        </div>
                                    </div>
                                    <div className='card-body row'>
                                        <div class="col-md-2">
                                            <label class="form-label" for="basic-icon-default-fullname">Tipo de Pagamento</label>
                                            <select id="defaultSelect" className="form-select" onChange={handleTipoPagamento}  >
                                                <option>Selecione</option>
                                                <option value={'eventos'} selected={tipoEvento === 'eventos' ? 'selected' : null}>Vídeos</option>
                                                <option value={'transmissao'} selected={tipoEvento === 'transmissao' ? 'selected' : null}>Transmissões</option>
                                            </select>
                                        </div>
                                        <div class="col-md-3">
                                            <label class="form-label" for="basic-icon-default-fullname">Mes/Ano</label>
                                            <input value={mesAno} onChange={handleMesAno} type="month" class="form-control" />
                                        </div>
                                        {tipoEvento == 'eventos' ?
                                            <div class="col-md-4">
                                                <label class="form-label" for="basic-icon-default-fullname">Por Vídeo</label>
                                                <select id="defaultSelect" className="form-select" onChange={handleEvento}  >
                                                    <option>Selecione</option>
                                                    <option value={'all'}>Todos</option>
                                                    {eventos.map((evento) =>
                                                        <option value={evento.id} >{evento.nome}</option>
                                                    )}
                                                </select>
                                            </div>
                                            :
                                            <div class="col-md-3">
                                                <label class="form-label" for="basic-icon-default-fullname">Por Transmissão</label>
                                                <select id="defaultSelect" className="form-select" onChange={handleEvento}  >
                                                    <option>Selecione</option>
                                                    <option value={'all'}>Todos</option>
                                                    {transmissoes.map((evento) =>
                                                        <option value={evento.id} >{evento.nome}</option>
                                                    )}
                                                </select>
                                            </div>
                                        }

                                        <div class="col-md-2" style={{ marginTop: 30 }}>
                                            <button onClick={() => filtrar()} type="submit" className="btn btn-primary me-2">Filtrar</button>
                                        </div>
                                        {academias.length > 0 ?
                                            <div class="col-md-2" style={{ marginTop: 30 }}>
                                                <button onClick={() => exportToExcel(academias)} type="submit" className="btn btn-success me-2">Exportar em Excel</button>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                    <div className="table-responsive text-nowrap">
                                        <div class="container-xxl flex-grow-1 container-p-y">
                                            <div class="row">
                                                <div class="col-xl-12">
                                                    <div class="nav-align-top mb-4">
                                                        <ul class="nav nav-tabs" role="tablist">
                                                            <li class="nav-item">
                                                                <button
                                                                    type="button"
                                                                    class="nav-link active"
                                                                    role="tab"
                                                                    data-bs-toggle="tab"
                                                                    data-bs-target="#navs-top-todos"
                                                                    aria-controls="navs-top-todos"
                                                                    aria-selected="true">
                                                                    Todos
                                                                </button>
                                                            </li>
                                                            <li class="nav-item">
                                                                <button
                                                                    type="button"
                                                                    class="nav-link"
                                                                    role="tab"
                                                                    data-bs-toggle="tab"
                                                                    data-bs-target="#navs-top-pagos"
                                                                    aria-controls="navs-top-pagos"
                                                                    aria-selected="false">
                                                                    Pagos
                                                                </button>
                                                            </li>
                                                            <li class="nav-item">
                                                                <button
                                                                    type="button"
                                                                    class="nav-link"
                                                                    role="tab"
                                                                    data-bs-toggle="tab"
                                                                    data-bs-target="#navs-top-vips"
                                                                    aria-controls="navs-top-vips"
                                                                    aria-selected="false">
                                                                    Vips
                                                                </button>
                                                            </li>
                                                            {tipoEvento !== 'eventos' ?
                                                                <li class="nav-item">
                                                                    <button
                                                                        type="button"
                                                                        class="nav-link"
                                                                        role="tab"
                                                                        data-bs-toggle="tab"
                                                                        data-bs-target="#navs-top-free"
                                                                        aria-controls="navs-top-free"
                                                                        aria-selected="false">
                                                                        Free
                                                                    </button>
                                                                </li>
                                                                :
                                                                null
                                                            }

                                                        </ul>
                                                        <div class="tab-content">
                                                            <div class="tab-pane fade show active" id="navs-top-todos" role="tabpanel">
                                                                {tipoEvento === 'eventos' ?
                                                                    <TabelaPagamentosVideos data={academias} />
                                                                    :
                                                                    <TabelaPagamentos data={academias} />
                                                                }

                                                            </div>
                                                            <div class="tab-pane fade" id="navs-top-pagos" role="tabpanel">
                                                                {tipoEvento === 'eventos' ?
                                                                    <TabelaPagamentosVideos data={academias.filter((d) => d.salaVip === false)} />
                                                                    :
                                                                    <TabelaPagamentos data={academias.filter((d) => d.salaVip === false && (d.free === false || d.free === null))} />
                                                                }
                                                            </div>
                                                            <div class="tab-pane fade" id="navs-top-vips" role="tabpanel">
                                                                {tipoEvento === 'eventos' ?
                                                                    <TabelaPagamentosVideos data={academias.filter((d) => d.salaVip)} />
                                                                    :
                                                                    <TabelaPagamentos data={academias.filter((d) => d.salaVip)} />
                                                                }
                                                            </div>
                                                            <div class="tab-pane fade" id="navs-top-free" role="tabpanel">
                                                                {tipoEvento === 'eventos' ?
                                                                    <TabelaPagamentosVideos data={academias.filter((d) => d.free === true)} />
                                                                    :
                                                                    <TabelaPagamentos data={academias.filter((d) => d.free === true)} />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <Footer />
                            <div className="content-backdrop fade" />
                        </div>
                        {/* Content wrapper */}
                    </div>
                </div>

            </div>
        </div>

    );
}
